import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/utils/auth'
import Login from '../views/login.vue'
import Index from '../views/index.vue'
import Gydetail from '../views/gydetail.vue'
import Yjbj from '../views/yjbj.vue'


import User from '../views/user/index.vue'
import Jydd from '../views/user/jydd.vue'
import Tkgl from '../views/user/tkgl.vue'
import Zhsz from '../views/user/zhsz.vue'
import Shxx from '../views/user/shxx.vue'

import Mobile from '../views/mobile/index.vue'
import Indexdetail from '../views/mobile/indexdetail.vue'
import Indexorder from '../views/mobile/indexorder.vue'


import Gz from '../views/mobile/gz.vue'
import Gzdetail from '../views/mobile/gzdetail.vue'

import Tz from '../views/mobile/tz.vue'
import Ls from '../views/mobile/ls.vue'
import Lssj from '../views/mobile/lssj.vue'

import Loading from '../views/loading.vue'



Vue.use(Router)

const router = new Router({
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index
    },
    {
      path: '/user',
      name: 'user',
      component: User,
      redirect: '/jydd',
      children: [
        {
          path: '/jydd',
          name: 'jydd',
          component: Jydd
        },
        {
          path: '/tkgl',
          name: 'tkgl',
          component: Tkgl
        },
        {
          path: '/zhsz',
          name: 'zhsz',
          component: Zhsz
        },
        {
          path: '/shxx',
          name: 'shxx',
          component: Shxx
        }
      ]
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: Mobile,
    },
    {
      path: '/indexdetail',
      name: 'indexdetail',
      component: Indexdetail,
    },
    {
      path: '/indexorder',
      name: 'indexorder',
      component: Indexorder,
    },
    {
      path: '/gz',
      name: 'gz',
      component: Gz,
    },
    {
      path: '/gzdetail',
      name: 'gzdetail',
      component: Gzdetail,
    },
    {
      path: '/tz',
      name: 'tz',
      component: Tz,
    },
    {
      path: '/ls',
      name: 'ls',
      component: Ls,
    },
    {
      path: '/lssj',
      name: 'lssj',
      component: Lssj,
    },
    {
      path: '/yjbj',
      name: 'yjbj',
      component: Yjbj
    },
    {
      path: '/gydetail',
      name: 'gydetail',
      component: Gydetail
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    }
  ]

})


// 导航守卫
// 参数1 : to 目标路由对象
// 参数2 : from 来源路由对象
// 参数3 : next() 下一步
router.beforeEach((to, from, next) => {
  document.title = '广材帮客户端';
  // 1. 判断是不是登录页面
  // 是登录页面
  if (to.path === '/login' || to.path === '/loading') {
    next()
  } else {
    // 不是登录页面
    // 2. 判断 是否登录过
    let token = getToken('token')
    token ? next() : next('/login')
  }
})

export default router